import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { IBaseServerConfiguration } from '../interfaces/base-server-configuration.interface';
import { HttpClient } from '@angular/common/http';
import { CONFIG_URL } from '../constants/consts';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';

declare var global: any;

@Injectable()
export class ServerConfigurationService {
    private _appConfigs: IBaseServerConfiguration;
    private isBrowser: boolean;
    // tslint:disable-next-line:max-line-length
    constructor(
        private httpSvc: HttpClient,
        @Inject(PLATFORM_ID) private platformId: any,
        @Inject(CONFIG_URL) private configUrl: string
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    load() {
        return this.httpSvc
            .get<IBaseServerConfiguration>(this.configUrl)
            .pipe(
                catchError(
                    (error: any): any => {
                        console.log(
                            `Configuration file "${this.configUrl.substring(
                                this.configUrl.lastIndexOf('/') + 1
                            )}" could not be read`
                        );
                        return Observable.throw(error || 'Server error');
                    }
                )
            )
            .toPromise()
            .then(res => {
                this._appConfigs = res as IBaseServerConfiguration;
                if (!this.isBrowser) {
                    try {
                        //replace https to http only in server.
                        this._appConfigs.apiUrl = this._appConfigs.apiUrl.replace(
                            'https',
                            'http'
                        );
                    } catch (error) {
                        console.log(
                            'error in ServerConfigurationService: ' +
                                error.toString()
                        );
                    }
                }
            });
    }

    public getAppConfigs<T extends IBaseServerConfiguration>(): T {
        return <T>this._appConfigs;
    }
}
